module.exports = __webpack_public_path__ + "img/banner1.0f68aa74.png";